var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1C13.0588 1 16.5 4.42803 16.5 8.5869C16.5 12.812 13.0028 15.777 9.7725 17.7932C9.5371 17.9287 9.2709 18 9 18C8.7291 18 8.4629 17.9287 8.2275 17.7932C5.00325 15.7573 1.5 12.8266 1.5 8.5869C1.5 4.42803 4.9412 1 9 1Z",
    stroke: "#5754E5",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.5C12 10.1569 10.6569 11.5 9 11.5C7.3431 11.5 6 10.1569 6 8.5C6 6.84315 7.3431 5.5 9 5.5C10.6569 5.5 12 6.84315 12 8.5Z",
    stroke: "#5754E5",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17C16.2447 17.4244 17 17.9819 17 18.5925C17 19.9221 13.4183 21 9 21C4.58172 21 1 19.9221 1 18.5925C1 17.9819 1.75527 17.4244 3 17",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/maps.da43df3af2dd68f3508e13ddd81511eb.svg";
export { ForwardRef as ReactComponent };